import { AfterContentInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AwallComponentEvent } from '../../../../models/awallComponentEvent';
import { UserstoryService } from '../../../../services/userstory.service';
import { SettingsService } from '../../../../services/settings.service';
import { AbstractKanbanGrid } from '../AbstractKanbanGrid';
import { Listener, CommunicationService } from '../../../../services/communication.service';

@Component({
  selector: 'app-kanban-grid-noswimlane',
  templateUrl: './kanban-grid-noswimlane.component.html',
  styleUrls: ['./kanban-grid-noswimlane.component.scss']
  })
export class KanbanGridNoswimlaneComponent extends AbstractKanbanGrid implements AfterContentInit, Listener<AwallComponentEvent> {

  public static readonly componentId = 'KanbanGridNoswimlaneComponent';
  @ViewChild('kanbanNoSwimlane') input;

  constructor(
    protected communicationService: CommunicationService,
    protected userStoryService: UserstoryService,
    protected settingsService: SettingsService
  ) {
    super(communicationService, userStoryService, settingsService);
  }

  public prepareIssues(userStoriesData) {
    this.taskboardData = [];

    this.data.boardConfiguration.columns.forEach(column => {
      const columnEntry = {};
      let numOfIssues = 0;

      columnEntry['name'] = column.name;
      // TODO handling for columns with multiple statuses will need to be determinded at a later point in time
      columnEntry['id'] = column.statuses[0].id;
      columnEntry['type'] = column.getStatusCategoryKey();
      columnEntry['tasks'] = [];

      userStoriesData.forEach(task => {
        if (column.statusMatchesIssue(task)) {
          columnEntry['tasks'].push(task);
          numOfIssues++;
        }
        task.tasks.forEach(subtask => {
          if (column.statusMatchesIssue(subtask)) {
            columnEntry['tasks'].push(subtask);
            numOfIssues++;
          }
        });
      });
      column.setNumIssues(numOfIssues);
      this.taskboardData.push(columnEntry);
    });
    console.log('issueData: ');
    console.log(this.taskboardData);
  }
}
